'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/WhiteLabel';
import handleChange from 'Components/Forms/Functions/handleChange';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import PhoneIcon from 'Icons/Phone';
import MapIcon from 'Icons/Map';
import BuildingIcon from 'Icons/BuildingIcon';
import numeral from 'numeral';
import moment from 'moment';
import BookingComponent from 'Components/Front/Booking/BookingComponentInit';
import CoworkingSpace from 'Components/Front/CoworkingSpace';
import Loader from 'Pure/Loader';
import Image from 'Pure/Image';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Select from 'Components/Forms/Elements/Select';
import TextInput from 'Components/Forms/Elements/TextInput';
import bemit from 'Functions/bemit';
import { days_config, b_seminar_ranges } from 'Shared/options';
import { safeNumeral, getMinMaxSeats, isTrue, num, getUrlParameter, getOpenInfos } from 'Shared/utilities';
import { coworking_place_types as type_options } from 'Shared/options';
import { action } from 'Shared/Routes';
const myWO_logo = '/images/logo_myWO_full.png';
const {
  app,
  qwest
} = window;
export default class DirectBookingPage extends Component {
  state = {
    loading: true,
    status_messages: {},
    step: -1,
    paid: false,
    type: 'all',
    'widget-people': window.localStorage.getItem('widget-people') || '1',
    'widget-date': window.localStorage.getItem('widget-date') || moment().add(1, 'day').format('YYYY-MM-DD'),
    breadcrumb: [{
      name: 'current-page',
      label: 'Réservation',
      url: document.location.pathname
    }]
  };
  requests = {};
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'StartWhiteLabelBooking',
      cb: component.startBooking
    });
    if (!window.localStorage.getItem('widget-date')) {
      window.localStorage.setItem('widget-date', moment().add(1, 'day').format('YYYY-MM-DD'));
      component.setState({
        'widget-date': moment().add(1, 'day').format('YYYY-MM-DD')
      });
    }
    if (!window.localStorage.getItem('widget-people')) {
      window.localStorage.setItem('widget-people', "1");
      component.setState({
        'widget-people': "1"
      });
    }
    component.fetchData({});
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_state.spaces?.length !== state.spaces?.length && isTrue(getUrlParameter('oauth'))) {
      component.startBooking({
        source: 'DidUpdate'
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    Object.keys(component.requests).forEach(name => component.requests[name]?.abort());
    component.requests = {};
    app.delete({
      event: 'StartWhiteLabelBooking',
      cb: component.startBooking
    });
  }
  startBooking = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = {
      people: window.localStorage.getItem('widget-people') || '',
      date: window.localStorage.getItem('widget-date') || '',
      start: window.localStorage.getItem('widget-start') || '',
      end: window.localStorage.getItem('widget-end') || '',
      amount: window.localStorage.getItem('amount') || '',
      disposition: window.localStorage.getItem('widget-disposition') || ''
    };
    const space_id = window.localStorage.getItem('booking-space-id');
    component.setState({
      step: isTrue(getUrlParameter('oauth')) ? 1 : 0,
      ...update,
      space: state.spaces.find(space => space.id === space_id)
    });
    component.fetchAvailability({
      ...update
    });
  };
  fetchData = ({
    type
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    let url = document.location.pathname.replace('/reservation', '');
    if (url.endsWith('/')) url = url.slice(0, -1);
    let slug = url.slice(url.lastIndexOf('/') + 1);
    component.requests['fetchData'] = qwest.post(action('getAllFrontSpaces'), {
      etablishment_slug: slug,
      'type': type ? type : state.type,
      striptags: false
    }).then(function (xhr, response) {
      const establishment = ((response.data || [])[0] || {})._etablishment;
      const root = document.querySelector(':root');
      if (root) {
        const background = establishment?.wl_background?.[0]?.url;
        if (background) {
          root.style.setProperty('--white-label-booking-background', 'url(' + background + ')');
        }
      }
      component.setState({
        loading: false,
        establishment: establishment,
        spaces: (response.data || []).map(function (data) {
          data.min_max_seats = getMinMaxSeats(data);
          return data;
        })
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchAvailability = ({
    date,
    people
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.requests['fetchAvailability']) {
      component.requests['fetchAvailability']?.abort();
      delete component.requests['fetchAvailability'];
    }
    const people_count = parseInt(safeNumeral(people));
    const space_id = window.localStorage.getItem('booking-space-id');
    const space = state.spaces.find(space => space.id === space_id);
    if (!space) return;
    component.setState({
      loading: true
    });
    const [is__open, is__custom] = getOpenInfos({
      schedule: space.schedule,
      availability: space.availabilities,
      type: space.type,
      date: date
    });
    if (!is__open) {
      return component.setState({
        loading: false,
        closed: true,
        special_closing: is__custom
      });
    }
    const seats = numeral(safeNumeral(space?.number_seat)).format('0');
    component.requests['fetchAvailability'] = qwest.post(action('getSpaceBooking'), {
      coworking_space_id: space_id,
      date: date
    }).then(function (xhr, response) {
      if (!component.requests['fetchAvailability']) return;
      delete component.requests['fetchAvailability'];
      numeral.locale('en');
      moment.locale('fr');
      const day = days_config[moment(date).isoWeekday() - 1];
      if (space.type === 'a_calm_coworking_space') {
        const schedule = space.schedule[day] || {};
        const hours_range = numeral(safeNumeral(schedule.to)).subtract(safeNumeral(schedule.from)).value();
        const availability = Array.from({
          length: hours_range
        }).map(function (nothing, i) {
          const start_hour = numeral(safeNumeral(schedule.from)).add(i).format('0');
          const infos = {
            start: start_hour + 'h',
            end: numeral(start_hour).add(1).format('0') + 'h'
          };
          const booking_infos = response.booking.find(booking => booking.hour === start_hour);
          infos.remaining_seats = numeral(seats).subtract(safeNumeral(booking_infos?.people_count)).format('0');
          if (infos.remaining_seats <= 0) {
            infos.remaining_seats = '0';
          }
          infos.too_little_seats = infos.remaining_seats < people_count;
          if (infos.too_little_seats) {
            infos.available = false;
          }
          return infos;
        }).filter(infos => infos.available !== false);
        return component.setState({
          availability: availability,
          closed: false,
          loading: false
        });
      }
      const bookings = response.booking || [];
      const availability = b_seminar_ranges.filter(opt => opt.value !== 'day').map(function (config, i) {
        const infos = {
          start: config.value
        };
        const [is__open, is__custom] = getOpenInfos({
          schedule: space.schedule,
          availability: space.availabilities,
          type: space.type,
          date: date,
          period: config.value
        });
        infos.available = is__open;
        if (space.type === 'c_open_coworking_space') {
          infos.remaining_seats = numeral(safeNumeral(seats));
          let morning = 0,
            afternoon = 0;
          bookings.filter(booking => booking.type !== 'day').forEach(function (booking) {
            if (booking.type === 'morning') {
              morning += num(booking.people_count);
            } else {
              afternoon += num(booking.people_count);
            }
          });
          if (morning > afternoon) {
            infos.remaining_seats.subtract(safeNumeral(morning));
          } else {
            infos.remaining_seats.subtract(safeNumeral(afternoon));
          }
          infos.remaining_seats = infos.remaining_seats.format('0');
          if (infos.remaining_seats > 0 === false) {
            infos.remaining_seats = '0';
          }
          infos.too_little_seats = infos.remaining_seats < people_count;
          if (infos.too_little_seats) {
            infos.available = false;
          }
        } else if (bookings?.[0]?.type === 'day')
          // seminar
          {
            infos.available = false;
          } else
          // seminar
          {
            if (is__custom && !is__open) {
              infos.available_type = 'close';
            }
            if (is__open) {
              const booking = bookings.find(booking => booking.type === config.value);
              infos.available = !booking;
            }
          }
        return infos;
      }).filter(infos => infos.available !== false);
      component.setState({
        availability: availability,
        closed: false,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      if (!component.requests['fetchAvailability']) return;
      delete component.requests['fetchAvailability'];
      component.setState(getErrorsFromResponse({
        response
      }));
    });
  };
  handleChange = ({
    e,
    value,
    name,
    ...params
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (name === 'widget-date') {
      window.localStorage.setItem('widget-date', value);
    }
    if (name === 'widget-people') {
      if (value === '0') {
        value = '1';
      }
      window.localStorage.setItem('widget-people', value);
    }
    if (name === 'type') {
      component.fetchData({
        [name]: value
      });
    }
    handleChange.bind(this)({
      e,
      value,
      name,
      ...params
    });
  };
  addOnePeople = e => {
    const component = this,
      props = this.props,
      state = this.state;
    numeral.locale('en');
    const value = numeral(safeNumeral(state['widget-people'])).add(1).format('0');
    component.setState({
      'widget-people': value > 0 ? value : '1'
    });
  };
  removeOnePeople = e => {
    const component = this,
      props = this.props,
      state = this.state;
    numeral.locale('en');
    const value = numeral(safeNumeral(state['widget-people'])).subtract(1).format('0');
    component.setState({
      'widget-people': value > 0 ? value : '1'
    });
  };
  handlePaymentSuccess = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      paid: true
    });
  };
  reset = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      step: -1
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    const establishment = state.establishment;
    const fetch_loader = state.loading === true && !establishment ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    const spaces = (state.step === -1 ? state.spaces || [] : []).map(function (data) {
      const output = /*#__PURE__*/React.createElement(CoworkingSpace, _extends({
        key: data.id
      }, data, {
        bemit: ['space'],
        "layout-type": "side",
        date: state['widget-date'],
        people: state['widget-people'],
        availability: true,
        "white-label-booking": true
      }));
      return output;
    });
    const logo = establishment?.wl_logo?.[0]?.url || myWO_logo;
    const establishment_name = establishment?.name;
    const hotel_name = establishment?.address?.hotel_name;
    let est_address = establishment?.address || {};
    let address = [est_address?.line_1 || '', ' ', est_address?.line_2 || '', ', ', est_address?.postal_code || '', ' ', est_address?.city || ''].join('');
    const output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      meta_title: state.meta_title
    }), /*#__PURE__*/React.createElement("div", {
      className: "page-container direct-booking"
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-positioned"
    }, /*#__PURE__*/React.createElement("div", {
      className: "direct-booking__top-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "direct-booking__top-header-col"
    }, /*#__PURE__*/React.createElement(Image, {
      className: "direct-booking__logo",
      src: logo,
      alt: 'Logo ' + establishment_name
    })), /*#__PURE__*/React.createElement("div", {
      className: "direct-booking__top-header-col"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-title c-title--direct-booking"
    }, establishment_name), /*#__PURE__*/React.createElement("div", {
      className: "direct-booking__top-header-hotel"
    }, /*#__PURE__*/React.createElement(BuildingIcon, null), hotel_name), /*#__PURE__*/React.createElement("div", {
      className: "direct-booking__top-header-address"
    }, /*#__PURE__*/React.createElement(MapIcon, null), /*#__PURE__*/React.createElement("span", null, "Adresse : "), address), /*#__PURE__*/React.createElement("a", {
      href: "tel:" + establishment?.phone_number,
      className: "direct-booking__top-header-phone"
    }, /*#__PURE__*/React.createElement(PhoneIcon, null), /*#__PURE__*/React.createElement("span", null, "T\xE9l\xE9phone : "), establishment?.phone_number)), /*#__PURE__*/React.createElement("div", {
      className: "direct-booking__top-header-col"
    })), state.spaces && state.step === -1 ? /*#__PURE__*/React.createElement("div", {
      className: "c-direct-booking_filters"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-widget__element date"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: state.type_id,
      className: "c-widget__label"
    }, "Date"), /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['widget-date'],
      name: "widget-date",
      "allow-no-value": true,
      "no-past": true,
      status: state.status_messages,
      "btn-class": bemit('c-flat-btn', ['primary', 'front', 'date'])
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-widget__element choice"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: state.type_id,
      className: "c-widget__label"
    }, "Type"), /*#__PURE__*/React.createElement(Select, {
      className: "c-widget__select",
      name: "type",
      onChange: component.handleChange,
      value: state['type'],
      options: type_options,
      id: state.type_id,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__element people"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: state.people_id,
      className: "c-side-widget__label"
    }, "Personne(s)"), /*#__PURE__*/React.createElement("div", {
      className: "c-side-widget__container"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-btn', ['less']) + ' u-margin-right-10',
      onClick: component.removeOnePeople
    }, "- 1 si\xE8ge"), /*#__PURE__*/React.createElement(TextInput, {
      className: "c-side-widget__input",
      name: "widget-people",
      onChange: component.handleChange,
      value: state['widget-people'],
      id: state.people_id,
      status: state.status_messages,
      "safe-value": true,
      int: true,
      inputMode: "numeric",
      min: "1"
    }), /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-btn', ['more']) + ' u-margin-left-10',
      onClick: component.addOnePeople
    }, "+ 1 si\xE8ge")))) : undefined, fetch_loader), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-positioned"
    }, spaces, loader), state.step > -1 && state.availability ? /*#__PURE__*/React.createElement("div", {
      className: "o-content u-positioned"
    }, /*#__PURE__*/React.createElement(BookingComponent, {
      space: state.space,
      etablishment: state.establishment,
      availability: state.availability,
      date: state.date,
      people: state.people,
      start: state.start,
      end: state.end,
      amount: state.amount,
      disposition: state.disposition,
      "white-label-booking": true,
      onPaymentSuccess: component.handlePaymentSuccess,
      source: 'DirectBookingPage-' + establishment?.id,
      reset: component.reset
    })) : undefined, getFormStatus(state))));
    return output;
  }
}
